import { VueModule } from '@Foundation/utilities';
import articleProven from './code/Scripts/components/article-proven.vue';

export default VueModule({
    components: {
        articleProven
    }
});